<app-sidebar>
  <div class="new-request-container">
    <h1>Search Trust</h1>

    <mat-card>
      <mat-card-content>
        <mat-tab-group [(selectedIndex)]="selectedTabIndex">
          <mat-tab label="Search">
            <div class="tab-content">
              <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
                <div class="id-list-section" formArrayName="trustNumbers">
                  <div *ngFor="let ctrl of trustNumbers.controls; let i = index" class="id-row">
                    <mat-form-field appearance="outline" class="id-input">
                      <mat-label>Trust Number {{ i + 1 }}</mat-label>
                      <input
                        matInput
                        type="text"
                        [formControlName]="i"
                        placeholder="e.g. IT123456/2024 or 123456/2024"
                        (paste)="i === 0 && onTrustPaste($event)">
                      <mat-hint>Accepted: IT/MT prefix optional, slash + year</mat-hint>
                      <mat-error *ngIf="ctrl?.hasError('invalidTrustNumber')">
                        Trust number is invalid
                      </mat-error>
                    </mat-form-field>
                    <div class="id-row-actions">
                      <button
                        type="button"
                        mat-icon-button
                        color="warn"
                        (click)="removeTrustField(i)"
                        *ngIf="trustNumbers.length > 1">
                        <mat-icon>remove</mat-icon>
                      </button>
                      <button
                        type="button"
                        mat-icon-button
                        color="primary"
                        (click)="addTrustField()"
                        [disabled]="trustNumbers.length >= maxTrustNumbers"
                        [matTooltip]="'Add another trust number (max ' + maxTrustNumbers + ')'">
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="tab-action-row">
                  <button
                    mat-raised-button
                    class="primary-search-button"
                    color="primary"
                    type="submit"
                    [disabled]="!requestForm.valid || !hasAnyTrustNumber || isSubmitting">
                    {{ isSubmitting ? 'Searching...' : 'Search' }}
                  </button>
                </div>
              </form>
            </div>
          </mat-tab>

          <mat-tab label="File Upload">
            <div class="tab-content">
              <div class="info-text">
                <p>Upload a CSV or Excel (xlsx) file up to 1MB. The first 20 non-empty rows are preserved in order.</p>
              </div>

              <div class="upload-actions">
                <button
                  mat-stroked-button
                  class="choose-file-button"
                  color="primary"
                  type="button"
                  (click)="uploadInput.click()">
                  Choose File
                </button>
              </div>

              <input
                #uploadInput
                class="file-input"
                hidden
                type="file"
                accept=".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                (change)="onUploadFileSelected($event)">

              <div class="upload-meta" *ngIf="uploadedFileName">
                <p><strong>File:</strong> {{ uploadedFileName }}</p>
                <p class="upload-status-text">{{ uploadParseStatusMessage }}</p>
              </div>

              <div class="tab-action-row">
                <button
                  mat-raised-button
                  class="primary-search-button"
                  color="primary"
                  type="button"
                  [disabled]="parsedUploadEntries.length < 1 || isSubmitting"
                  (click)="submitUploadedTrusts()">
                  {{ isSubmitting ? 'Searching...' : 'Search' }}
                </button>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</app-sidebar>
